import Roadmap from "../roadmap";
import { DLBanner } from "./DLBanner";
import { FAQ } from "./FAQ";
import { Features } from "./Features";
import { Hero } from "./hero";

export const Landing = () => {
  return (
    <>
      <Hero />
      <Features />
      <Roadmap />
      <FAQ />
      <DLBanner />
    </>
  );
};
